import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const items = [
  { icon: 'ri-water-flash-line', key: 'verif_ent_1' },
  { icon: 'ri-stack-line', key: 'verif_ent_2' },
  { icon: 'ri-eye-line', key: 'verif_ent_3' },
  { icon: 'ri-bug-line', key: 'verif_ent_4' },
  { icon: 'ri-hammer-line', key: 'verif_ent_5' },
  { icon: 'ri-windy-line', key: 'verif_ent_6' },
];

export default function VerificationsEntretoit() {
  const { t } = useTranslation('blogsignes');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="verif-entretoit" className="scroll-mt-28">
      <h2
        className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-6 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        {t('verif_entretoit_h2')}
      </h2>

      <p className={`text-slate-primary/70 text-base md:text-lg leading-relaxed mb-6 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('verif_entretoit_intro')}
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        {items.map((item, idx) => (
          <div
            key={idx}
            className={`flex items-start gap-3 bg-white border border-soft-gray rounded-lg p-4 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: `${idx * 80 + 150}ms` }}
          >
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-copper/10 shrink-0 mt-0.5">
              <i className={`${item.icon} text-copper text-sm`} />
            </div>
            <span className="text-slate-primary/80 text-sm md:text-base">{t(item.key)}</span>
          </div>
        ))}
      </div>

      <div className={`bg-amber-50 border border-amber-200 rounded-lg p-4 flex items-start gap-3 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-amber-100 shrink-0">
          <i className="ri-error-warning-line text-amber-600" />
        </div>
        <p className="text-amber-800 text-sm md:text-base leading-relaxed">{t('verif_entretoit_conseil')}</p>
      </div>
    </section>
  );
}